import React, { useState } from "react";
import posthog from "posthog-js";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { isWhiteLabelClient } from "../../../utils/utilities";
import Button from "../../../components/sub-component/Button";
import TextArea from "../../../components/sub-component/TextArea";
import { patchAssessment } from "../../../redux/thunks/Assessment";
import { ReactComponent as SadIcon } from "../../../assets/icons/candidate-assessment/2.svg";
import { ReactComponent as MehIcon } from "../../../assets/icons/candidate-assessment/3.svg";
import { ReactComponent as AngryIcon } from "../../../assets/icons/candidate-assessment/1.svg";
import { ReactComponent as SmileIcon } from "../../../assets/icons/candidate-assessment/4.svg";
import { ReactComponent as HappyIcon } from "../../../assets/icons/candidate-assessment/5.svg";
import { ReactComponent as TestFuseLogoIcon } from "../../../assets/icons/logo/logo.svg";
import { ReactComponent as TestFuseWatermarkIcon } from "../../../assets/icons/candidate-assessment/Watermark.svg";

export default function AssessmentReview({ assessment }) {
  const params = useParams();
  const dispatch = useDispatch();
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState("");

  const ratingData = [
    { icon: <AngryIcon />, value: 1 },
    { icon: <SadIcon />, value: 2 },
    { icon: <MehIcon />, value: 3 },
    { icon: <SmileIcon />, value: 4 },
    { icon: <HappyIcon />, value: 5 },
  ];

  const handlePatchAssessment = (data) => {
    dispatch(patchAssessment({ id: params.id, data }));
  };

  const handleRatingClick = (selectedRating) => {
    setRating(selectedRating);
  };

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleSubmitAssessFeedback = () => {
    if (rating || comment) {
      posthog.capture("survey sent", {
        $survey_id: window._env_?.REACT_APP_POSTHOG_SURVEY_ID,
        $survey_response: rating,
        $survey_response_1: comment,
        $survey_response_2: params.id,
        $survey_response_3: assessment?.spec_id,
      });
    }
    handlePatchAssessment({ has_submitted_review: true });
    setRating(null);
    setComment("");
  };

  return (
    <div className="candidate-assessment-flow-container">
      <div
        className="candidate-assment-flow-wrapper"
        style={{ height: "80vh" }}
      >
        {isWhiteLabelClient() ? (
          <div className="candidate-assessment-feedack-modal">
            <span className="headline-3 dark-100 text-center">Thank You!</span>
            <span className="body-2 dark-100 text-start">
              Your assessment has been submitted successfully. Please share your
              experience with us.
            </span>
            <div className="emoji-container">
              {ratingData?.map((r, i) => {
                return (
                  <span
                    key={i}
                    className={`emoji-icon ${rating == r.value && "selected"}`}
                    onClick={() => handleRatingClick(r?.value)}
                  >
                    {r?.icon}
                  </span>
                );
              })}
            </div>
            <div style={{ width: "100%", maxHeight: "170px" }}>
              <TextArea
                placeholder="Please Explain..."
                name="message"
                inputStyle={{ height: "105px", maxHeight: "145px" }}
                value={comment}
                onChange={handleCommentChange}
              />
            </div>
            <div className="candidate-assessment-feedack-modal-text">
              <span className="body-2 dark-100 text-start">
                Some of the assessment results will be available to you right
                away on your dashboard. Others might take several minutes to
                show up.
              </span>
              <span className="body-2 dark-100 text-start">
                Thank you for using Testfuse!
              </span>
            </div>
            <div className="d-flex justify-content-center">
              <Button
                btn="ragular-btn"
                varrient="primary"
                title={"Next"}
                style={{
                  width: "fit-content",
                  padding: "0.875em 2em 0.875em 2em",
                }}
                onClick={() => {
                  handleSubmitAssessFeedback();
                }}
              />
            </div>
          </div>
        ) : (
          <div className="candidate-assessment-feedack-modal">
            <TestFuseLogoIcon
              style={{ height: "50px", marginBottom: "24px" }}
            />
            <div
              className="candidate-assessment-feedack-modal-text"
              style={{ gap: "24px" }}
            >
              <span className="body-1 dark-100 text-start">
                This assessment was powered by Testfuse, a job fit assessments
                platform.
              </span>
              <span className="body-1 dark-100 text-start">
                When you take an assessment on our platform, we keep your test
                scores with us and you can use them again in future assessments.
              </span>
              <span className="body-1 dark-100 text-start">
                This means that you will never have to take the same test over
                and over again for assessments that happen on our platform.
              </span>
              <span className="body-1 dark-100 text-start">
                Please rate your experience on our platform:
              </span>
            </div>
            <div className="emoji-container">
              {ratingData?.map((r, i) => {
                return (
                  <span
                    key={i}
                    className={`emoji-icon ${rating == r.value && "selected"}`}
                    onClick={() => handleRatingClick(r?.value)}
                  >
                    {r?.icon}
                  </span>
                );
              })}
            </div>
            <div style={{ width: "100%", maxHeight: "170px" }}>
              <TextArea
                placeholder="Please Explain..."
                name="message"
                inputStyle={{ height: "105px", maxHeight: "145px" }}
                value={comment}
                onChange={handleCommentChange}
              />
            </div>
            <div className="d-flex justify-content-center">
              <Button
                btn="ragular-btn"
                varrient="primary"
                title={"Next"}
                style={{
                  width: "fit-content",
                  padding: "0.875em 2em 0.875em 2em",
                }}
                onClick={() => {
                  handleSubmitAssessFeedback();
                }}
              />
            </div>
          </div>
        )}
      </div>
      <div className="watermark">
        {isWhiteLabelClient() ? (
          <></>
        ) : (
          <TestFuseWatermarkIcon style={{ height: "50px" }} />
        )}
      </div>
    </div>
  );
}
